// extracted by mini-css-extract-plugin
module.exports = {"itemHolder":"EmailSkinnableItem_itemHolder__Qd6yS","uploadIcon":"EmailSkinnableItem_uploadIcon__1LvZc"};